/**
 * Common utilities for Redux reducers
 */

import { IBasicState } from "@src/types"

/**
 * Basic initial state used across multiple reducers
 */
export const basicInitialState: IBasicState = {
  error: undefined,
  isLoading: false,
  message: "",
  success: false,
}
